import React from 'react'
import Layout from '../Components/Layout'

export default function Forbidden() {
  return (
    <Layout>
      <h2 className="text-light" style={{ fontWeight: 600 }}>Forbidden</h2>
      <div className="text-light" style={{ fontWeight: 600 }}>No tiene acceso al recurso solicitado</div>
    </Layout>
  )
}
